import "./sidebar.scss";
import React from "react";
import { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DigitalSignage from "../../../Assets/svgs/DigitalSignagelogo.svg";
import BoostBoard from "../../../Assets/svgs/boostboard_logo.svg"
import DashboardIcon from "@mui/icons-material/Dashboard";
import GridViewIcon from '@mui/icons-material/GridView';
import WebIcon from "@mui/icons-material/Web";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { Box, Button, Divider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ListItemIcon, ListItemText } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TuneIcon from "@mui/icons-material/Tune";
import { Logout } from "@mui/icons-material";
import { useLogoutMutation } from "../../../Redux/service/AllEmpData";
import { toast } from "react-toastify";
import { captureeventbaseanalytics } from "../../../Analytics/Google/AllAnalytics/Capturing";
import {
  GetCookie,
  LoadingSpinner,
  RemoveCookie,
} from "../../../Libraries/Authentication/Login";
import PropTypes from "prop-types";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import {  Typography } from "@mui/material";
import Nayatel_Logo from "../../../Assets/svgs/Nayatel_Logo.svg"
const mdTheme = createTheme();

const Sidebar = ({ handletoggle, toggle }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [logout, { isLoading }] = useLogoutMutation();

  const handleListItemClick = useCallback((event, index) => {
    setSelectedIndex(index);
  }, []);


  useEffect(() => {
    if (location.pathname === "/dashboard") {
      handleListItemClick(Event, 1);
    } else if (location.pathname === "/screens") {
      handleListItemClick(Event, 3);
    }
     else if (location.pathname === "/groups") {
      handleListItemClick(Event, 4);
    } 
    else if (location.pathname === "/media") {
      handleListItemClick(Event, 2);
    }
    else if (location.pathname === "/userinfo") {
      handleListItemClick(Event, 5);
    }
    else if (location.pathname === "/billing") {
      handleListItemClick(Event, 5);
    }
     else if (location.pathname === "/posts") {
      handleListItemClick(Event, 3);
    } else if (location.pathname === "/pinghistory") {
      handleListItemClick(Event, 3);
    } else if (location.pathname === "/addnewpost") {
      handleListItemClick(Event, 3);
    } else if (location.pathname === "/editPost") {
      handleListItemClick(Event, 3);
    } else {
      handleListItemClick(Event, -1);
    }
  }, [location, handleListItemClick]);

  const LogoutUser = async () => {
    const payload = new FormData();
    payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
    payload.append("security_token", await GetCookie("es_token"));
    payload.append("session_id", await GetCookie("session_id")); //added by maheen for api shifting

    try {
      const res = await logout(payload).unwrap();
      if (
        res.status === "true" &&
        res.connection === "true" &&
        res.message === "Logout successfully"
      ) {
        captureeventbaseanalytics("logout", "logout.php RESPONSE", res.message);
        localStorage.removeItem("txt_customer_id");
        RemoveCookie("es_token");
        RemoveCookie("session_id"); //added by maheen for api shifting
        RemoveCookie("is_first_time_login");
        localStorage.removeItem("txt_customer_id");
        navigate("/login");
      } else {
        captureeventbaseanalytics("logout", "logout.php RESPONSE", res.message);
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error.message);
      console.log(error);
      captureeventbaseanalytics("logout", "logout.php RESPONSE", error.message);
    }
  };

  return (
    <React.Fragment>
      {isLoading ? <LoadingSpinner /> : null}
      <ThemeProvider theme={mdTheme}>
        <Box
          className="sidebar"
          sx={{
            width: {
              xs: toggle && "270px",
              sm: toggle && "270px",
              md: "270px",
              lg: "270px",
              xl: "270px",
            },
          }}
        >
          <div className="p-0 sidebar__logo">
            <img
              src={BoostBoard}
              alt="logo"
              height="auto"
              width="200"
              onClick={() => handletoggle()}
            />
          </div>
          <CssBaseline />
          <Box sx={{ flexGrow: 1 }}>
            <Divider />
            <List component="nav" sx={{ p: 2 }}>
              <Link to="/dashboard">
                <ListItemButton
                  key="dashboard"
                  selected={selectedIndex === 1}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 1)}
                >
                  <ListItemIcon>{<DashboardIcon />}</ListItemIcon>
                  <ListItemText primary="Dashboard" />
                </ListItemButton>
              </Link>

              <Link to="/media">
                <ListItemButton
                  key="media"
                  selected={selectedIndex === 2}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 2)}
                >
                  <ListItemIcon>{<SaveAsIcon />}</ListItemIcon>
                  <ListItemText primary="Media" />
                </ListItemButton>
              </Link>

              <Link to="/screens">
                <ListItemButton
                  key="screens"
                  selected={selectedIndex === 3}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 3)}
                >
                  <ListItemIcon>{<WebIcon />}</ListItemIcon>
                  <ListItemText primary="Screens" />
                </ListItemButton>
              </Link>

               <Link to="/groups">
                <ListItemButton
                  key="groups"
                  selected={selectedIndex === 4}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 4)}
                >
                  <ListItemIcon>{<GridViewIcon />}</ListItemIcon>
                  <ListItemText primary="Groups" />
                </ListItemButton>
              </Link>

              <Link to="/userinfo">
                <ListItemButton
                  key="userinfo"
                  selected={selectedIndex === 5}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 5)}
                >
                  <ListItemIcon>{<AccountCircleIcon />}</ListItemIcon>
                  <ListItemText primary="Profile" />
                </ListItemButton>
              </Link>

              {/* <Link to="/billing">
                <ListItemButton
                  key="billing"
                  selected={selectedIndex === 5}
                  sx={{ borderRadius: "8px" }}
                  onClick={(event) => handleListItemClick(event, 5)}
                >
                  <ListItemIcon>{<CreditCardIcon />}</ListItemIcon>
                  <ListItemText primary="billing" />
                </ListItemButton>
              </Link> */}
              {/* <Link to="/customization">
                <ListItemButton
                  button="true"
                  key="customization"
                  sx={{ borderRadius: "8px" }}
                  selected={selectedIndex === 4}
                  onClick={(event) => handleListItemClick(event, 4)}
                >
                  <ListItemIcon>{<TuneIcon />}</ListItemIcon>
                  <ListItemText primary="Customization" />
                </ListItemButton>
              </Link> */}
            </List>
          </Box>
          {/* <Box sx={{width: "50%",margin:"0 auto",display:'flex',flexDirection:"column", marginBottom: "1.7rem"}}>
            <Typography style={{color:'757575',fontStyle:'italic',fontSize:'16px',textAlign:"left",fontWeight:"bold"}} variant="h6">Powered by</Typography>
            <img
              src={Nayatel_Logo}
              alt="nayatel_img"
              style={{ maxWidth: "60%",marginLeft:"auto"}}
            />
          </Box> */}
          <Box component="nav" sx={{ p: 2 }}>
            <Button
              variant="contained"
              className="capitalized fs-14 fw-bold"
              onClick={LogoutUser}
              disableElevation
              sx={{
                width: "100%",
                minHeight: "45px",
                backgroundColor: "rgba(26, 117, 232, 1)",
                color: "#FFFFFF",
                borderRadius: "8px",
              }}
              startIcon={<Logout />}
            >
              Logout
            </Button>
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  toggle: PropTypes.bool,
  handletoggle: PropTypes.func,
};

export default Sidebar;